import React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import TipsAndUpdatesRoundedIcon from "@mui/icons-material/TipsAndUpdatesRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import CoffeeRoundedIcon from "@mui/icons-material/CoffeeRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import DesktopWindowsRoundedIcon from "@mui/icons-material/DesktopWindowsRounded";
import PsychologyRoundedIcon from "@mui/icons-material/PsychologyRounded";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import FeedbackRoundedIcon from "@mui/icons-material/FeedbackRounded";

const tips = [
  {
    title: "Choose how you work",
    icon: TuneRoundedIcon,
    body: (
      <span className="help-mode-options">
        <span>
          <strong>Creative Mode:</strong> Create timed tasks, work flexibly,
          and review your performance.
        </span>
        <span>
          <strong>Consistency Mode:</strong> Save a routine in{" "}
          <strong>Menu → My Presets → New preset</strong>, then add the full
          schedule with one click.
        </span>
      </span>
    ),
  },
  {
    title: "Schedule intentional breaks",
    icon: CoffeeRoundedIcon,
    body: "Use the coffee icon to schedule a break. Each click adds 5 minutes, up to a maximum of 25 minutes.",
  },
  {
    title: "Use boosters when needed",
    icon: BoltRoundedIcon,
    body: "If a task genuinely needs more time, use the booster to add 2 extra minutes. You can extend a task up to 20 minutes while keeping the session on track.",
  },
  {
    title: "Keep the timer visible",
    icon: DesktopWindowsRoundedIcon,
    body: "On a desk or laptop, try a 70:30 split: work on 70% of the screen and keep Glow Panda on 30%. You can also track it from a separate phone or tablet.",
  },
  {
    title: "Notice your escape patterns",
    icon: PsychologyRoundedIcon,
    body: "Pay attention to the reasons your mind gives you to quit or switch tasks. Recognizing these escape tactics helps you understand and improve your work habits.",
  },
  {
    title: "Add many tasks at once",
    icon: PlaylistAddRoundedIcon,
    body: (
      <>
        Paste a list such as{" "}
        <code>[Read:10, Exercise:5, Sleep:10]</code>. Task durations can be
        between 1 and 99 minutes.
      </>
    ),
  },
];

const Help = ({ onClose }) => {
  return (
    <div className="help-overlay" onClick={onClose} role="presentation">
      <section
        className="help-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="help-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="help-panel-header">
          <div>
            <span className="help-panel-header-icon">
              <TipsAndUpdatesRoundedIcon />
            </span>
            <div>
              <h2 id="help-title">Glow Panda Guide</h2>
              <p>Helpful guidance for planning and staying focused.</p>
            </div>
          </div>
          <button type="button" onClick={onClose} aria-label="Close tips">
            <CloseRoundedIcon />
          </button>
        </header>

        <div className="help-panel-content">
          <section className="help-section help-tips-section">
            <h3 className="help-section-title">Quick tips</h3>
            <div className="help-tip-list">
              {tips.map((tip) => {
                const TipIcon = tip.icon;

                return (
                  <article className="help-tip" key={tip.title}>
                    <span className="help-tip-icon">
                      <TipIcon />
                    </span>
                    <div>
                      <h3>{tip.title}</h3>
                      <p>{tip.body}</p>
                    </div>
                  </article>
                );
              })}
            </div>
          </section>

          <section className="help-section help-feedback-section">
            <h3 className="help-section-title">Feedback</h3>
            <aside className="help-feedback">
              <span>
                <FeedbackRoundedIcon />
              </span>
              <div>
                <strong>Have a suggestion?</strong>
                <small>Tell us about your experience.</small>
              </div>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfUB9iqqm1T0VgpcjhROPODxzDG2BMcR43ZG4A2HD9sZzrVhg/viewform?usp=dialog"
                target="_blank"
                rel="noreferrer"
              >
                Give feedback
              </a>
            </aside>
          </section>
        </div>
      </section>
    </div>
  );
};

export default Help;
